import { createContext, useState } from "react";

const ChairContext = createContext();

export function ChairProvider({ children }) {
  //
  //
  const [onCrocoTexture, setOnCrocoTexture] = useState(false);
  const [onMatFabric, setOnMatFabric] = useState(false);
  const [onGlossyTexture, setOnGlossyTexture] = useState(false);
  //
  //
  const handleCrocoTexture = (e) => {
    e.stopPropagation();
    setOnCrocoTexture(true);
    setOnMatFabric(false);
    setOnGlossyTexture(false);
  };
  const handlerMatFabric = (e) => {
    e.stopPropagation();
    setOnMatFabric(true);
    setOnCrocoTexture(false);
    setOnGlossyTexture(false);
  };

  const handlerGlossy = (e) => {
    e.stopPropagation();
    setOnGlossyTexture(true);
    setOnCrocoTexture(false);
    setOnMatFabric(false);
  };
  //
  //
  return (
    //
    //
    <ChairContext.Provider
      value={{
        onCrocoTexture,
        setOnCrocoTexture,
        handleCrocoTexture,
        //
        onMatFabric,
        setOnMatFabric,
        handlerMatFabric,
        //
        onGlossyTexture,
        setOnGlossyTexture,
        handlerGlossy,
      }}
    >
      {children}
    </ChairContext.Provider>
  );
}
export default ChairContext;
